// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select_select__OlUEn {
    padding: 0 14px 0 22px;
}

.Select_select__OlUEn input {
    position: absolute;
}

.Select_select__OlUEn > div > div {
    max-width: 95%;
    text-wrap: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.Select_select__OlUEn.Select_focused__HFtZg {
    background: #fff;
}

.Select_menuList__mz1Ks {
    padding: 1px;
}

.Select_option__3JR2v {
    padding: 3px 16px;
    border: 4px solid #fff;
    transition: background-color 0.4s;
    border-radius: 8px;
}

.Select_optionCompact__wYGyN {
    padding: 5px 9px;
    transition: background-color 0.4s;
    border-radius: 3px;
    margin: 2px 0;
}

.Select_optionCompact__wYGyN.Select_readOnly__Ajq0V {
    color: var(--dark-grey);
}

.Select_optionCompact__wYGyN:not(.Select_readOnly__Ajq0V) {
    cursor: pointer !important;
}

.Select_optionOuter__h37ui.Select_borderTop__ZMz5f {
    border-top: 1px solid var(--light-grey);
    padding-top: 4px;
    margin-top: 4px;
}

.Select_optionOuter__h37ui.Select_borderBottom__I77ih {
    padding-bottom: 4px;
    margin-bottom: 4px;
    border-bottom: 1px solid var(--light-grey);
}

.Select_dropdownCustom__VFQRP .Select_dropdownCustom__VFQRP:hover  > .Select_dropdownMenuItem__\\+9Wy1 .Select_optionCompact__wYGyN:not(.Select_readOnly__Ajq0V),
.Select_option__3JR2v:hover:not(.Select_readOnly__Ajq0V),
.Select_optionCompact__wYGyN:hover:not(.Select_readOnly__Ajq0V)
/*.optionSelected */ {
    background: rgba(214, 214, 214, 0.5);
}

.Select_optionSelected__zVtn\\+ {
    color: var(--primary-color);
    --icon-color-custom: var(--primary-color);
}

.Select_clearIndicator__n0hli {
    color: var(--light-grey);
}

.Select_noOptionsMessage__LnXru {
    padding: 6px;
}

.Select_readOnly__Ajq0V.Select_noOptionsMessage__LnXru {
    display: none;
}

.Select_multiValue__hJ-Xn {
    background-color: #ececec;
    padding: 2px 4px;
    border-radius: 6px;
    color: #3f3f3f;
    border: 1px solid #fff;
}

.Select_addOptionContainer__NZOLv {
    border-top: 1px solid var(--light-grey);
    margin: 0 3px;
}

.Select_addOptionBtn__-zR\\+o {
    width: 100%;
    color: #1650b4;
    border-radius: 0;
    padding: 6px 18px;
    text-align: left;
    font-size: 14px;
    display: flex;
    grid-gap: 12px;
    align-items: center;
}

.Select_addOptionBtn__-zR\\+o svg {
    width: 21px;
    height: 21px;
}

.Select_filter__-pOhw {
    color: #7b848e;
    padding: 2px 4px;
    border-radius: 2px;
    font-size: 14px;
    min-width: 35px;
}

.Select_filter__-pOhw:not(:last-child) {
    margin-right: 6px;
}

.Select_selectedFilter__6m7Y0 {
    background: #fff;
    color: #000;
}

.Select_filterContainer__BI5O1 {
    display: flex;
    gap: 16px;
    padding: 0 19px;
    border-bottom: 1px solid var(--light-grey);
    margin: 0 3px;
}

.Select_filtersOuter__OrahI {
    /*display: inline-block;*/
    /*min-width: 100%;*/
    overflow: auto;
    white-space: nowrap;
}

.Select_filters__ae-1g:before {
    content: '';
    background: rgba(214, 214, 214, 0.5);
    position: absolute;
    top: 20%;
    left: 0;
    width: 100%;
    height: 60%;
    display: block;
    border-radius: 3px;
    z-index: -1;
}

.Select_filters__ae-1g {
    position: relative;
    padding: 11px 3px;
    border-radius: 3px;
    /*background: rgba(214, 214, 214, 0.5);*/
    column-gap: 6px;
    row-gap: 3px;
    /*display: flex;*/
    /*align-items: center;*/
    /*overflow: auto;*/
    /*white-space: nowrap;*/
    min-width: 100%;
    display: inline-block;
}

.Select_filterStatus__pHlnt {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: auto 0 auto auto;
}

.Select_selectedFiltersIndicator__i3TI0 {
    background: #f2f3f4;
    color: rgba(123, 132, 142, 0.5);
    padding: 2px 6px;
    min-width: 20px;
    min-height: 20px;
    border-radius: 2px;
}

.Select_dropdownMenu__t5UwT {
    position: absolute;
    z-index: 10;
    background: #fff;
    width: 100%;
    border: 0.5px solid #7b848e;
    border-radius: 0;
    /*bottom: placement === 'top' ? '100%' : 'initial',*/
    /*marginTop: placement === 'top' ? '0' : '-1px',*/
    /*marginBottom: placement === 'top' ? '-1px' : '0',*/
    /*borderTopWidth: placement === 'top' ? '0.5px' : '0',*/
    /*borderBottomWidth: placement === 'top' ? '0' : '0.5px',*/
    /*boxShadow: placement === 'top' ? '0 -3px 6px rgba(0,0,0,0.16)' : '0 3px 6px rgba(0,0,0,0.16)',*/
}

.Select_dropdownTop__qyWqq {
    bottom: 100%;
    border-bottom-width: 0;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.16);
    margin-bottom: calc(var(--input-h) * -1);
    padding-bottom: var(--input-h);
}

.Select_dropdownBottom__JZZHZ {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.Select_dropdownBottom__JZZHZ:not(.Select_dropdownMenuCustom__0M5No) {
    border-top-width: 0;
    margin-top: calc(var(--input-h) * -1);
    padding-top: var(--input-h);
}

.Select_dropdownCustom__VFQRP {
    position: relative;
    display: inline-block;
    /* Removes the outline when the container itself is focused */
    outline: none;
}

.Select_dropdownMenuCustom__0M5No {
    position: absolute;
    /*max-width: 100%;*/
    width: 170px;
    top: 100%;
    left: 0;
    visibility: hidden;
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.2s ease;
    background: white;
    border: 0.5px solid var(--dark-grey);
    border-radius: 2px;
    padding: 5px 5px;
    list-style: none;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.Select_dropdownMenuCustom__0M5No.Select_minWidth__3i\\+eq {
    width: 286px;
}

.Select_dropdownMenuCustomWideRight__og\\+fQ {
    min-width: 340px;
    right: 0;
    left: auto;
}

.Select_dropdownMenuCustomTop__o46\\+d {
    top: auto;
    bottom: 100%;
    transform: translateY(10px);
}

/* nested */
.Select_dropdownCustom__VFQRP .Select_dropdownCustom__VFQRP {
    width: 100%;
}

.Select_dropdownCustom__VFQRP .Select_dropdownCustom__VFQRP .Select_dropdownMenuCustom__0M5No {
    left: 100%;
    top: 10%;
}

/* Show the menu when the button or any child is focused */
.Select_dropdownCustom__VFQRP:focus-within > .Select_dropdownMenuCustom__0M5No {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
}

.Select_dropdownMenuCustom__0M5No .Select_dropdownCustom__VFQRP:focus-within > .Select_dropdownMenuCustom__0M5No {
    visibility: hidden;
    opacity: 0;
}

.Select_dropdownCustom__VFQRP .Select_dropdownCustom__VFQRP:hover > .Select_dropdownMenuCustom__0M5No {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
}

.Select_dropdownMenuItem__\\+9Wy1,
.Select_dropdownMenuItemInner__ihWGY {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.Select_dropdownMenuItem__\\+9Wy1 {
    justify-content: space-between;
}

.Select_optionOuter__h37ui,
.Select_option__3JR2v,
.Select_optionCompact__wYGyN {
    width: 100%;
    display: flex;
    align-items: center;
}

.Select_optionOuter__h37ui .Select_option__3JR2v {
    width: 100%;
}

.Select_iconRight__Ivkcc {
    color: var(--dark-grey);
}

.Select_dropdownMenuItemDisabled__eeSK3 {
    opacity: 0.55;
    cursor: default !important;
    pointer-events: none;
}

.Select_dropdownMenuItemInner__ihWGY {
    width: 100%;
}

.Select_dropdownMenuItemInnerLabel__OHmiD {
    flex-grow: 1;
    margin: auto 0;
    display: flex;
    /*align-items: center;*/
    justify-content: center;
    flex-direction: column;
}

.Select_dropdownMenuItemInnerSubLabel__PfTL8 {
    color: var(--dark-grey);
    font-size: 14px;
}

.Select_dropdownMenuItemInnerWithIcon__zJHaB > span:first-child {
    width: 20px;
    height: 20px;
    text-align: center;
    justify-content: center;
}

.Select_dropdownMenuItemInnerWithIcon__zJHaB {
    grid-gap: 10px;
}

.Select_icon-base__EKUQb {
}

.Select_icon-md__Z8GVe > span:first-child {
    width: 32px;
    height: 32px;
}

.Select_dropdownCustom__VFQRP.Select_fixed__jY3Y7 .Select_dropdownMenuCustom__0M5No {
    position: fixed;
    bottom: 100px;
    left: 0;
    top: unset;
    width: 240px;
    margin-bottom: 0;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .Select_select__OlUEn {
        padding: 0 14px 0 22px;
    }

    .Select_input__p5KTa > div {
        max-width: 300px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Select/Select.module.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;;;;IAII,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oDAAoD;IACpD,iDAAiD;IACjD,oDAAoD;IACpD,uDAAuD;IACvD,0DAA0D;IAC1D,iGAAiG;AACrG;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,0CAA0C;IAC1C,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,6DAA6D;IAC7D,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,4BAA4B;IAC5B,yBAAyB;IACzB,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,2BAA2B;AAC/B;;AAEA,WAAW;AACX;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA,0DAA0D;AAC1D;IACI,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;IAGI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;AACA;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,OAAO;IACP,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["@value screen-lg-min, screen-md-max from '../../breakpoints.css';\n\n.select {\n    padding: 0 14px 0 22px;\n}\n\n.select input {\n    position: absolute;\n}\n\n.select > div > div {\n    max-width: 95%;\n    text-wrap: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.select.focused {\n    background: #fff;\n}\n\n.menuList {\n    padding: 1px;\n}\n\n.option {\n    padding: 3px 16px;\n    border: 4px solid #fff;\n    transition: background-color 0.4s;\n    border-radius: 8px;\n}\n\n.optionCompact {\n    padding: 5px 9px;\n    transition: background-color 0.4s;\n    border-radius: 3px;\n    margin: 2px 0;\n}\n\n.optionCompact.readOnly {\n    color: var(--dark-grey);\n}\n\n.optionCompact:not(.readOnly) {\n    cursor: pointer !important;\n}\n\n.optionOuter.borderTop {\n    border-top: 1px solid var(--light-grey);\n    padding-top: 4px;\n    margin-top: 4px;\n}\n\n.optionOuter.borderBottom {\n    padding-bottom: 4px;\n    margin-bottom: 4px;\n    border-bottom: 1px solid var(--light-grey);\n}\n\n.dropdownCustom .dropdownCustom:hover  > .dropdownMenuItem .optionCompact:not(.readOnly),\n.option:hover:not(.readOnly),\n.optionCompact:hover:not(.readOnly)\n/*.optionSelected */ {\n    background: rgba(214, 214, 214, 0.5);\n}\n\n.optionSelected {\n    color: var(--primary-color);\n    --icon-color-custom: var(--primary-color);\n}\n\n.clearIndicator {\n    color: var(--light-grey);\n}\n\n.noOptionsMessage {\n    padding: 6px;\n}\n\n.readOnly.noOptionsMessage {\n    display: none;\n}\n\n.multiValue {\n    background-color: #ececec;\n    padding: 2px 4px;\n    border-radius: 6px;\n    color: #3f3f3f;\n    border: 1px solid #fff;\n}\n\n.addOptionContainer {\n    border-top: 1px solid var(--light-grey);\n    margin: 0 3px;\n}\n\n.addOptionBtn {\n    width: 100%;\n    color: #1650b4;\n    border-radius: 0;\n    padding: 6px 18px;\n    text-align: left;\n    font-size: 14px;\n    display: flex;\n    grid-gap: 12px;\n    align-items: center;\n}\n\n.addOptionBtn svg {\n    width: 21px;\n    height: 21px;\n}\n\n.filter {\n    color: #7b848e;\n    padding: 2px 4px;\n    border-radius: 2px;\n    font-size: 14px;\n    min-width: 35px;\n}\n\n.filter:not(:last-child) {\n    margin-right: 6px;\n}\n\n.selectedFilter {\n    background: #fff;\n    color: #000;\n}\n\n.filterContainer {\n    display: flex;\n    gap: 16px;\n    padding: 0 19px;\n    border-bottom: 1px solid var(--light-grey);\n    margin: 0 3px;\n}\n\n.filtersOuter {\n    /*display: inline-block;*/\n    /*min-width: 100%;*/\n    overflow: auto;\n    white-space: nowrap;\n}\n\n.filters:before {\n    content: '';\n    background: rgba(214, 214, 214, 0.5);\n    position: absolute;\n    top: 20%;\n    left: 0;\n    width: 100%;\n    height: 60%;\n    display: block;\n    border-radius: 3px;\n    z-index: -1;\n}\n\n.filters {\n    position: relative;\n    padding: 11px 3px;\n    border-radius: 3px;\n    /*background: rgba(214, 214, 214, 0.5);*/\n    column-gap: 6px;\n    row-gap: 3px;\n    /*display: flex;*/\n    /*align-items: center;*/\n    /*overflow: auto;*/\n    /*white-space: nowrap;*/\n    min-width: 100%;\n    display: inline-block;\n}\n\n.filterStatus {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin: auto 0 auto auto;\n}\n\n.selectedFiltersIndicator {\n    background: #f2f3f4;\n    color: rgba(123, 132, 142, 0.5);\n    padding: 2px 6px;\n    min-width: 20px;\n    min-height: 20px;\n    border-radius: 2px;\n}\n\n.dropdownMenu {\n    position: absolute;\n    z-index: 10;\n    background: #fff;\n    width: 100%;\n    border: 0.5px solid #7b848e;\n    border-radius: 0;\n    /*bottom: placement === 'top' ? '100%' : 'initial',*/\n    /*marginTop: placement === 'top' ? '0' : '-1px',*/\n    /*marginBottom: placement === 'top' ? '-1px' : '0',*/\n    /*borderTopWidth: placement === 'top' ? '0.5px' : '0',*/\n    /*borderBottomWidth: placement === 'top' ? '0' : '0.5px',*/\n    /*boxShadow: placement === 'top' ? '0 -3px 6px rgba(0,0,0,0.16)' : '0 3px 6px rgba(0,0,0,0.16)',*/\n}\n\n.dropdownTop {\n    bottom: 100%;\n    border-bottom-width: 0;\n    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.16);\n    margin-bottom: calc(var(--input-h) * -1);\n    padding-bottom: var(--input-h);\n}\n\n.dropdownBottom {\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n}\n\n.dropdownBottom:not(.dropdownMenuCustom) {\n    border-top-width: 0;\n    margin-top: calc(var(--input-h) * -1);\n    padding-top: var(--input-h);\n}\n\n.dropdownCustom {\n    position: relative;\n    display: inline-block;\n    /* Removes the outline when the container itself is focused */\n    outline: none;\n}\n\n.dropdownMenuCustom {\n    position: absolute;\n    /*max-width: 100%;*/\n    width: 170px;\n    top: 100%;\n    left: 0;\n    visibility: hidden;\n    opacity: 0;\n    transform: translateY(-10px);\n    transition: all 0.2s ease;\n    background: white;\n    border: 0.5px solid var(--dark-grey);\n    border-radius: 2px;\n    padding: 5px 5px;\n    list-style: none;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n}\n\n.dropdownMenuCustom.minWidth {\n    width: 286px;\n}\n\n.dropdownMenuCustomWideRight {\n    min-width: 340px;\n    right: 0;\n    left: auto;\n}\n\n.dropdownMenuCustomTop {\n    top: auto;\n    bottom: 100%;\n    transform: translateY(10px);\n}\n\n/* nested */\n.dropdownCustom .dropdownCustom {\n    width: 100%;\n}\n\n.dropdownCustom .dropdownCustom .dropdownMenuCustom {\n    left: 100%;\n    top: 10%;\n}\n\n/* Show the menu when the button or any child is focused */\n.dropdownCustom:focus-within > .dropdownMenuCustom {\n    visibility: visible;\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.dropdownMenuCustom .dropdownCustom:focus-within > .dropdownMenuCustom {\n    visibility: hidden;\n    opacity: 0;\n}\n\n.dropdownCustom .dropdownCustom:hover > .dropdownMenuCustom {\n    visibility: visible;\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.dropdownMenuItem,\n.dropdownMenuItemInner {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.dropdownMenuItem {\n    justify-content: space-between;\n}\n\n.optionOuter,\n.option,\n.optionCompact {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.optionOuter .option {\n    width: 100%;\n}\n\n.iconRight {\n    color: var(--dark-grey);\n}\n\n.dropdownMenuItemDisabled {\n    opacity: 0.55;\n    cursor: default !important;\n    pointer-events: none;\n}\n\n.dropdownMenuItemInner {\n    width: 100%;\n}\n\n.dropdownMenuItemInnerLabel {\n    flex-grow: 1;\n    margin: auto 0;\n    display: flex;\n    /*align-items: center;*/\n    justify-content: center;\n    flex-direction: column;\n}\n\n.dropdownMenuItemInnerSubLabel {\n    color: var(--dark-grey);\n    font-size: 14px;\n}\n\n.dropdownMenuItemInnerWithIcon > span:first-child {\n    width: 20px;\n    height: 20px;\n    text-align: center;\n    justify-content: center;\n}\n\n.dropdownMenuItemInnerWithIcon {\n    grid-gap: 10px;\n}\n\n.icon-base {\n}\n\n.icon-md > span:first-child {\n    width: 32px;\n    height: 32px;\n}\n\n.dropdownCustom.fixed .dropdownMenuCustom {\n    position: fixed;\n    bottom: 100px;\n    left: 0;\n    top: unset;\n    width: 240px;\n    margin-bottom: 0;\n}\n\n@media screen-md-max {\n    .select {\n        padding: 0 14px 0 22px;\n    }\n\n    .input > div {\n        max-width: 300px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"select": `Select_select__OlUEn`,
	"focused": `Select_focused__HFtZg`,
	"menuList": `Select_menuList__mz1Ks`,
	"option": `Select_option__3JR2v`,
	"optionCompact": `Select_optionCompact__wYGyN`,
	"readOnly": `Select_readOnly__Ajq0V`,
	"optionOuter": `Select_optionOuter__h37ui`,
	"borderTop": `Select_borderTop__ZMz5f`,
	"borderBottom": `Select_borderBottom__I77ih`,
	"dropdownCustom": `Select_dropdownCustom__VFQRP`,
	"dropdownMenuItem": `Select_dropdownMenuItem__+9Wy1`,
	"optionSelected": `Select_optionSelected__zVtn+`,
	"clearIndicator": `Select_clearIndicator__n0hli`,
	"noOptionsMessage": `Select_noOptionsMessage__LnXru`,
	"multiValue": `Select_multiValue__hJ-Xn`,
	"addOptionContainer": `Select_addOptionContainer__NZOLv`,
	"addOptionBtn": `Select_addOptionBtn__-zR+o`,
	"filter": `Select_filter__-pOhw`,
	"selectedFilter": `Select_selectedFilter__6m7Y0`,
	"filterContainer": `Select_filterContainer__BI5O1`,
	"filtersOuter": `Select_filtersOuter__OrahI`,
	"filters": `Select_filters__ae-1g`,
	"filterStatus": `Select_filterStatus__pHlnt`,
	"selectedFiltersIndicator": `Select_selectedFiltersIndicator__i3TI0`,
	"dropdownMenu": `Select_dropdownMenu__t5UwT`,
	"dropdownTop": `Select_dropdownTop__qyWqq`,
	"dropdownBottom": `Select_dropdownBottom__JZZHZ`,
	"dropdownMenuCustom": `Select_dropdownMenuCustom__0M5No`,
	"minWidth": `Select_minWidth__3i+eq`,
	"dropdownMenuCustomWideRight": `Select_dropdownMenuCustomWideRight__og+fQ`,
	"dropdownMenuCustomTop": `Select_dropdownMenuCustomTop__o46+d`,
	"dropdownMenuItemInner": `Select_dropdownMenuItemInner__ihWGY`,
	"iconRight": `Select_iconRight__Ivkcc`,
	"dropdownMenuItemDisabled": `Select_dropdownMenuItemDisabled__eeSK3`,
	"dropdownMenuItemInnerLabel": `Select_dropdownMenuItemInnerLabel__OHmiD`,
	"dropdownMenuItemInnerSubLabel": `Select_dropdownMenuItemInnerSubLabel__PfTL8`,
	"dropdownMenuItemInnerWithIcon": `Select_dropdownMenuItemInnerWithIcon__zJHaB`,
	"icon-base": `Select_icon-base__EKUQb`,
	"icon-md": `Select_icon-md__Z8GVe`,
	"fixed": `Select_fixed__jY3Y7`,
	"input": `Select_input__p5KTa`
};
export default ___CSS_LOADER_EXPORT___;
